module.exports = __webpack_public_path__ + "02_face.4a6fd356.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer1/02_face.png
// module id = Py0j
// module chunks = 0